import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Checkbox } from '../../../components/Checkbox';
import { Cell, List, Row } from '../../../components/List';
import { IsOpen } from '../../../components/Icon';
import cn from 'classnames';
import styles from './RDWandHistoryCard.module.css';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';


const Container = styled.div`
  font-size: 14px;
width: 100%;
  .info-card {
    min-width: 260px;
    width: 100%;
  }

  .cell:first-child {
    text-transform: capitalize;
  }

  .list-title {
    padding: 8px 0;
  }

  .history-block {
    padding: 0 5px;
    border: 1px solid #ddd;
  }

  td {
    font-size: 12px;
    border: 1px solid #d9d9d9;
  }

  & .td-aantalDagen {
    width: 16%;
    text-align: center;
  }
  & .td-datum {
    width: 24%;
  }

  & .td-extraInfo {
    width: 34%;
  }

  & .td-typeEigenaar {
    width: 28%;
    text-align: center;
  }
`;

const DateSheet = styled.div`
  border: 1px solid tomato;
`;

const STATE = {
   isOpen: env.clientId == AppClientId.AUTOWIENTJES ? true : false,
};





/* eslint-disable react/prefer-stateless-function */
class VehicleRDWandHistoryDataComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  

  componentDidMount() {}

  

  get ownerHistory() {
    return this.props.vehicle?.ownerHistory ? JSON.parse(this.props.vehicle?.ownerHistory) : null;
  }

  get parsedHistory() {
    return this.ownerHistory ? this.ownerHistory?.map(owner => this.parseOwner(owner)) : null;
  }

  get ownerProps() {
    return ['aantalDagen', 'datum', 'extraInfo', 'typeEigenaar'];
  }

  parseOwner(owner) {
    const parsedOwner = {};

    owner.map(prop => {
      parsedOwner[prop.propertyName] = prop.propertyValue;
    });

    return parsedOwner;
  }

  renderCell(cell, item) {
    const fn = () => {
      switch (cell) {
        case 'aantalDagen':
          return (
            <td className={`td-${cell}`} key={cell}>
              {item[cell]}
            </td>
          );
        case 'datum':
          return (
            <td className={`td-${cell}`} key={cell}>
              {item[cell]}
            </td>
          );
        case 'extraInfo':
          return (
            <td className={`td-${cell}`} key={cell}>
              {item[cell]}
            </td>
          );
        case 'typeEigenaar':
          return (
            <td className={`td-${cell}`} key={cell}>
              {item[cell]}
            </td>
          );
      }
    };
    return fn();
  }

  renderTable() {
    if (!this.ownerHistory) return;

    return (
      <table className={cn('table table-hover', styles.table)}>
        <thead className={cn('table-light', styles.thead)}>
          <tr>
            {this.ownerProps?.map(prop => (
              <th scope="col" key={prop}>
                {this.lbl(prop)}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {this.parsedHistory?.map((item, index) => {
            return (
              <tr key={index}>
                {this.ownerProps?.map(row => {
                  return this.renderCell(row, item);
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    return (
      <Container>
      <Card className={cn('vehicle-info-card info-card info', styles.card)}>

          <HBox>
            <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.info.data.rdw_and_history')}</h2>

              <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
                <IsOpen />
              </div>

          </HBox>
          {(this.state.isOpen) && (
            <>
              <div className={styles.containerTable}>{this.renderTable()}</div>

              <List>
                {['wok', 'pending_recall', 'design'].map(property => {
                  if (vehicle[property] && property == 'design') {
                    return (
                      <Row key={property}>
                        <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                        <Cell>{vehicle[property]}</Cell>
                      </Row>
                    );
                  }
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell>
                        {' '}
                        <Checkbox checked={vehicle[property] && vehicle[property] != '0'}></Checkbox>
                      </Cell>
                    </Row>
                  );
                })}
              </List>
            </>
          )}
          {
            vehicle.rdw_tenaamstellingen?.length ? <><div><hr /></div> <h2>Tenaamstellingen</h2> <List>{

              vehicle.rdw_tenaamstellingen.map(a => <Row key={a.id}><Cell>{a.date}</Cell></Row>)
            }
            </List></> : null

          }
      </Card>
      </Container>
    );
  }
}

VehicleRDWandHistoryDataComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}
 
const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleRDWandHistoryDataCard = compose(withConnect, withRouter)(VehicleRDWandHistoryDataComp);
